document.addEventListener('alpine:init', () => {
	Alpine.data('sc_collapse', (cfg) => ({
		id: cfg.id,
		_isExpanded: cfg.expanded || false,
		_hasAccordion: false,
		lockedClosed: cfg.lockedClosed || false,
	}));
});
